import { render, staticRenderFns } from "./BuscarTurnosEliminados.vue?vue&type=template&id=3c02daf2&scoped=true"
import script from "./BuscarTurnosEliminados.vue?vue&type=script&lang=js"
export * from "./BuscarTurnosEliminados.vue?vue&type=script&lang=js"
import style0 from "./BuscarTurnosEliminados.vue?vue&type=style&index=0&id=3c02daf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c02daf2",
  null
  
)

export default component.exports